export const COUNTRIES = {
  AR: "ARGENTINA",
  CL: "CHILE",
};

export const COUNTRIES_SHORT = {
  AR: "AR",
  CL: "CL",
};

const currencyByCountry = {
  [COUNTRIES_SHORT.AR]: "ARS",
  [COUNTRIES_SHORT.CL]: "CLP",
};

export const getCountries = () => {
  return Object.keys(COUNTRIES).map((id) => ({
    id,
    name: COUNTRIES[id],
  }));
};

export const getCountryId = (country) => {
  if (!country) return undefined;
  const normalizedCountry = country.trim().toUpperCase();
  return Object.entries(COUNTRIES).find(
    ([, name]) => name === normalizedCountry
  )?.[0];
};

export const getCurrencyByCountry = (countryId) =>
  currencyByCountry[countryId] ?? currencyByCountry[COUNTRIES_SHORT.AR];
